module.exports = __webpack_public_path__ + "static/fonts/ProximaNovaA-Bold.eea6b294.eot";